export var GotoResolveApp;
(function (GotoResolveApp) {
    GotoResolveApp[GotoResolveApp["RemoteExecution"] = 0] = "RemoteExecution";
    GotoResolveApp[GotoResolveApp["PatchManagement"] = 1] = "PatchManagement";
    GotoResolveApp[GotoResolveApp["Antivirus"] = 2] = "Antivirus";
    GotoResolveApp[GotoResolveApp["Alerts"] = 3] = "Alerts";
    GotoResolveApp[GotoResolveApp["Devices"] = 4] = "Devices";
})(GotoResolveApp || (GotoResolveApp = {}));
